import { render } from "./SeasonsTable.vue?vue&type=template&id=1177cde1"
import script from "./SeasonsTable.vue?vue&type=script&lang=js"
export * from "./SeasonsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__